var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFullActiveImgMsg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFullActiveImgMsg@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.7708333,23.75 L15.8333333,23.75 C14.7402698,23.75 13.8541667,22.8638969 13.8541667,21.7708333 L13.8541667,15.8333333 C13.8541667,14.7402698 14.7402698,13.8541667 15.8333333,13.8541667 L21.7708333,13.8541667 C22.8638969,13.8541667 23.75,14.7402698 23.75,15.8333333 L23.75,21.7708333 C23.75,22.8638969 22.8638969,23.75 21.7708333,23.75 Z M21.7708333,15.8333333 L15.8333333,15.8333333 L15.8333333,21.7708333 L21.7708333,21.7708333 L21.7708333,15.8333333 Z M21.7708333,9.89583333 L15.8333333,9.89583333 C14.7402698,9.89583333 13.8541667,9.00973023 13.8541667,7.91666667 L13.8541667,1.97916667 C13.8541667,0.886103099 14.7402698,0 15.8333333,0 L21.7708333,0 C22.8638969,0 23.75,0.886103099 23.75,1.97916667 L23.75,7.91666667 C23.75,9.00973023 22.8638969,9.89583333 21.7708333,9.89583333 Z M21.7708333,1.97916667 L15.8333333,1.97916667 L15.8333333,7.91666667 L21.7708333,7.91666667 L21.7708333,1.97916667 Z M7.91666667,23.75 L1.97916667,23.75 C0.886103099,23.75 0,22.8638969 0,21.7708333 L0,15.8333333 C0,14.7402698 0.886103099,13.8541667 1.97916667,13.8541667 L7.91666667,13.8541667 C9.00973023,13.8541667 9.89583333,14.7402698 9.89583333,15.8333333 L9.89583333,21.7708333 C9.89583333,22.8638969 9.00973023,23.75 7.91666667,23.75 Z M7.91666667,15.8333333 L1.97916667,15.8333333 L1.97916667,21.7708333 L7.91666667,21.7708333 L7.91666667,15.8333333 Z M7.91666667,9.89583333 L1.97916667,9.89583333 C0.886103099,9.89583333 0,9.00973023 0,7.91666667 L0,1.97916667 C0,0.886103099 0.886103099,0 1.97916667,0 L7.91666667,0 C9.00973023,0 9.89583333,0.886103099 9.89583333,1.97916667 L9.89583333,7.91666667 C9.89583333,9.00973023 9.00973023,9.89583333 7.91666667,9.89583333 Z M7.91666667,1.97916667 L1.97916667,1.97916667 L1.97916667,7.91666667 L7.91666667,7.91666667 L7.91666667,1.97916667 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "See-more-picture",
    transform: "translate(-333.000000, -92.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icFullActiveImgMsg",
    transform: "translate(333.125000, 92.125000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#101010",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/primary-green",
    mask: "url(#mask-2)",
    fill: "#7BCB45"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.916667, -7.916667)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 40 0 40 40 0 40"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFullActiveImgMsg);
export default __webpack_public_path__ + "static/media/icFullActiveImgMsg.df891ed70590f2ecb277d109b05d9bdf.svg";
export { ForwardRef as ReactComponent };